



















import { createComponent, ref } from "@vue/composition-api";
import BaseButton from "./BaseButton.vue";
import BaseDialog from "./BaseDialog.vue";

interface Props {
  title: string;
  width?: string;
  fullscreen: boolean;
  closeOnNavigation: boolean;
}

export default createComponent<Props>({
  components: { BaseDialog, BaseButton },
  props: {
    title: { type: String },
    width: { type: String },
    fullscreen: { type: Boolean, default: false },
    closeOnNavigation: { type: Boolean, default: false },
  },
  setup(props, ctx) {
    const visible = ref(false);
    return {
      visible,
      openDialog: () => {
        visible.value = true;
      },
      closeDialog: () => {
        visible.value = false;
      },
    };
  },
});
